exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "social-security-data{display:block}social-security-data span{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#0072c9;padding-left:10px;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/social-security.module/components/socialSecurityCard/socialSecurityData/socialSecurityData.scss
// module id = 2303
// module chunks = 0